export const SOFTLINE_API_MDE_INVENTUR_BEWEGUNGEN = '/v1/inventur/bewegung/entities'
export const SOFTLINE_API_MDE_INVENTUR_ABSCHLUSS = '/v1/inventur/abschluss'
export const SOFTLINE_API_MDE_INVENTUR_ARTIKEL = '/v1/inventur/artikel/entities'
export const SOFTLINE_API_MDE_INVENTUR_KOPF = '/v1/inventur'
export const SOFTLINE_API_MDE_INVENTUR_DEFAULT_LAGER = '/v1/inventur/lager'
export const SOFTLINE_API_MDE_INVENTUR_LAGERPLATZ_SCAN = '/v1/lagerplatz/scan/{{code}}'
export const SOFTLINE_API_MDE_INVENTUR_ARTIKEL_DETAIL = 'detail'
